import React, { createContext, useContext, useEffect, useState } from 'react';

import { getAuth, userLogin, adminLogin, userSignup, getUserData, userLogout, userPasswordCheck, userPasswordChange, planDescription, userDeleteAccount, userResetPassword, checkUsage, getPlanAddCount, checkFirstLogin, userDataChange, updateMarketing, googleAuth, tempLogin } from "@/api";
import useTranslation from '@/language/useTranslation';
import { useNavigate } from 'react-router-dom';
import { useAlert } from './AlertContext';
import { usePopup } from './PopupContext';
import { decryptAES } from '@/utils';
// 1. Context 생성
const UserContext = createContext(null);

// 2. Provider 컴포넌트
export const UserProvider = ({ children }) => {
	const alert = useAlert();
	const { showPopup } = usePopup();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [user, setUser] = useState(null);
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(true); // 유저 정보 로딩 상태
	const [loadingUserData, setLoadingUserData] = useState(true);
	const [userPlanData, setUserPlanData] = useState({
		plan: {
			storage: 0.0,
			total_count: 0
		},
		user: {
			email: "",
			username: ""
		},
		usageSize: 0,
		usageCount: 0,
		remainDays: 0

	});
	const [downloadModel, setDownloadModel] = useState({

		loading: 0,
		downloadUrl: ""

	});
	// 3. 서버에서 유저 정보 가져오기
	const authUser = async () => {
		setLoading(true);
		try {
			getAuth()
				.then(res => {
					if (res.data.success) {
						//setUser(res.data.user);
						const decryptedObj = decryptAES(res.data.user);
						if (user != decryptedObj)
							setUser(decryptedObj);
					} else {
						setUser(null);
					}
				})
				.catch(err => {
					console.log(err.message);
					setUser(null);
				});
		}
		catch (err) {
			console.log(err.message);
			setUser(null);

		}
		finally {
			setLoading(false);
		}

	};

	// 4. 초기 로딩 시 유저 체크
	useEffect(() => {
		authUser();
	}, [navigate]);

	const getData = async () => {
		setLoadingUserData(true);
		try {
			getUserData()
				.then(res => {
					if (res.data.success) {
						const decryptedObj = decryptAES(res.data.data);
						if (userPlanData != decryptedObj)
							setUserPlanData(decryptedObj);

						setLoadingUserData(false);
					} else {
						setUserPlanData(null);
					}
				})
				.catch(err => {
					setUserPlanData(null);
				});
		}
		catch (err) {
			setUserPlanData(null);
			console.log(err.message);
		}
		finally {

		}

	};

	// 4. 초기 로딩 시 유저 체크
	useEffect(() => {
		//if (user != null)
		getData();
	}, [user, navigate]);

	// 5. 로그인 처리
	const login = (email, password) => {
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("email", email);
			formData.append("password", password);
			return userLogin(formData)
				.then(res => {
					if (res.data.success) {
						const decryptedObj = decryptAES(res.data.user);

						setUser(decryptedObj);
					} else {
						setUser(null);
					}
					setLoading(false);
					return { success: res.data.success, status: res.status, message: res.data.message };
				})
				.catch(err => {
					console.log(err)
					setUser(null);
					return { success: false, status: err.response.status, message: err.message };
				});
		}
		catch (err) {
			console.log(err)
			setUser(null);
			return { success: false, status: null, message: null };

		}
		finally {
			setLoading(false);
		}
	};
	const adminLoginFunc = (email, password) => {
		setLoading(true);
		try {
			const formData = new FormData();
			formData.append("email", email);
			formData.append("password", password);
			return adminLogin(formData)
				.then(res => {
					if (res.data.success) {
						const decryptedObj = decryptAES(res.data.user);
						setUser(decryptedObj);
					} else {
						setUser(null);
					}
					setLoading(false);
					return { success: res.data.success, status: res.status, message: res.data.message };
				})
				.catch(err => {
					console.log(err)
					setUser(null);
					return { success: false, status: err.response?.status, message: err.message };
				});
		}
		catch (err) {
			console.log(err)
			setUser(null);
			return { success: false, status: null, message: null };
		}
		finally {
			setLoading(false);
		}
	};
	const userTempLogin = () => {
		setLoading(true);
		try {
			return tempLogin()
				.then(res => {
					if (res.data.success) {
						const decryptedObj = decryptAES(res.data.user);

						setUser(decryptedObj);
					} else {
						setUser(null);
					}

					setLoading(false);
					return { success: res.data.success, status: res.status, message: res.data.message };
				})
				.catch(err => {
					console.log(err.message)
					setUser(null);
					return { success: false, status: err.response.status, message: err.message };
				});
		}
		catch (err) {
			console.log(err);
			setUser(null);
			return { success: false, status: null, message: null };

		}
		finally {
			setLoading(false);
		}
	};
	const googleLogin = (token) => {
		try {
			const formData = new FormData();
			formData.append("token", token);
			return googleAuth(formData)
				.then(res => {
					if (res.data.success) {
						const decryptedObj = decryptAES(res.data.user);

						setUser(decryptedObj);
						return { success: res.data.success, user: decryptedObj };
					} else {
						setUser(null);
						return { success: res.data.success, user: null };
					}


				})
				.catch(err => {
					console.log(err.message)
					setUser(null);
					return { success: false, user: null };
				});
		}
		catch (err) {
			setUser(null);
			return { success: false, user: null };

		}
	}

	// 5. 로그인 처리
	const registerUser = (data) => {
		try {
			const formData = new FormData();
			formData.append("email", data.email);
			formData.append("password", data.password);
			formData.append("username", data.username);
			formData.append("company", data.company);
			formData.append("personalTerm", data.personalTerm);
			formData.append("marketingTerm", data.marketingTerm);
			return userSignup(formData)
				.then(res => {
					// if (res.data.success) {
					// 	setUser(res.data.user);
					// } else {
					// 	setUser(null);
					// }

					return { success: res.data.success, status: res.status, message: res.data.message };
				})
				.catch(err => {
					console.log(err.message)
					//setUser(null);
					return { success: false, status: err.response.status, message: res.data.message };
				});
		}
		catch (err) {
			//setUser(null);
			return { success: false, status: err.message };

		}
	};
	// 5. 로그인 처리
	const registerUserWithSocial = (data) => {
		try {
			const formData = new FormData();
			formData.append("email", data.email);
			formData.append("username", data.username);
			formData.append("password", null);
			formData.append("company", data.company);
			formData.append("personalTerm", data.personalTerm);
			formData.append("marketingTerm", data.marketingTerm);
			return userSignup(formData)
				.then(res => {
					// if (res.data.success) {
					// 	setUser(res.data.user);
					// } else {
					// 	setUser(null);
					// }

					return { success: res.data.success, status: res.status, message: res.data.message };
				})
				.catch(err => {
					console.log(err.message)
					//setUser(null);
					return { success: false, status: err.response.status, message: res.data.message };
				});
		}
		catch (err) {
			//setUser(null);
			return { success: false, status: err.message };

		}
	};
	// 5. 로그인 처리
	const resetPassword = (data) => {
		try {
			const formData = new FormData();
			formData.append("email", data.email);
			formData.append("password", data.password);
			return userResetPassword(formData)
				.then(res => {
					// if (res.data.success) {
					// 	setUser(res.data.user);
					// } else {
					// 	setUser(null);
					// }

					return { success: res.data.success, status: res.status };
				})
				.catch(err => {
					console.log(err.message)
					//setUser(null);
					return { success: false, status: err.response.status };
				});
		}
		catch (err) {
			//setUser(null);
			return { success: false, status: err.message };

		}
	};
	// 6. 로그아웃 처리
	const logout = () => {

		try {
			return userLogout()
				.then(res => {
					setUser(null);
					navigate('/');

				})
				.catch(err => {
					console.log(err.message)
					setUser(null);
					navigate('/');

				});
		}
		catch (err) {
			setUser(null);
			navigate('/');
		}

	};

	const updateUserData = () => {
		getData();
	}
	const getDownloadModel = async (downloadUrl) => {

		try {
			setDownloadModel(prevData => ({
				...prevData,
				loading: true,
				downloadUrl: downloadUrl,
			}));
			const response = await fetch(downloadUrl, {
				method: 'GET',
				headers: {
					Authorization: `Bearer ${process.env.REACT_APP_PMAUTOTWIN_TOKEN}`,
				},
				credentials: "include", // 쿠키/세션 포함
			});

			const blob = await response.blob();

			// Content-Disposition에서 파일명 추출
			const disposition = response.headers.get('Content-Disposition');
			let filename = 'downloaded-file';

			if (disposition) {
				const utf8FilenameRegex = /filename\*\=UTF-8''([^;]+)/i;
				const utf8Match = disposition.match(utf8FilenameRegex);
				if (utf8Match?.[1]) {
					filename = decodeURIComponent(utf8Match[1]);
				} else {
					const filenameRegex = /filename="?([^"]+)"?/i;
					const match = disposition.match(filenameRegex);
					if (match?.[1])
						filename = decodeURIComponent(match[1]);
				}
			} else {
				const urlParts = downloadUrl.split('/');
				filename = urlParts[urlParts.length - 1];
			}

			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			a.click();
			window.URL.revokeObjectURL(url);
			setDownloadModel(prevData => ({
				...prevData,
				loading: false,
				downloadUrl: "",
			}));
		} catch (err) {
			console.error('Download failed', err);
			setDownloadModel(prevData => ({
				...prevData,
				loading: false,
				downloadUrl: "",
			}));
		}
	}

	// 5. 로그인 처리
	const passwordCheck = async (password) => {
		try {
			const formData = new FormData();
			formData.append("password", password);
			return userPasswordCheck(formData)
				.then(res => {
					console.log(res.data);
					return res.data.success;
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		}
		catch (err) {
			return false;

		}
	};

	const passwordChange = async (userPassword) => {
		try {
			const formData = new FormData();
			formData.append("currentPassword", userPassword.currentPassword);
			formData.append("newPassword", userPassword.password);
			return userPasswordChange(formData)
				.then(res => {
					return res.data.success;
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		}
		catch (err) {
			console.log(err.message);
			return false;

		}
	};

	const userDataUpdate = async (userData) => {
		try {
			const formData = new FormData();
			formData.append("username", userData.username);
			formData.append("company", userData.company);
			return userDataChange(formData)
				.then(res => {
					authUser();
					return res.data.success;
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		}
		catch (err) {
			console.log(err.message);
			return false;

		}
	};
	const userMarketingUpdate = async (on) => {
		try {
			const formData = new FormData();
			formData.append("marketing", on);
			return updateMarketing(formData)
				.then(res => {
					authUser();
					return res.data.success;
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		}
		catch (err) {
			console.log(err.message);
			return false;

		}
	};

	const getPlanDescription = async () => {
		try {
			return planDescription({ planId: userPlanData.plan.id })
				.then(res => {
					return res.data.data;
				})
				.catch(err => {
					console.log(err.message)
					return null;
				});
		}
		catch (err) {
			return null;

		}
	};
	const deleteAccount = async () => {
		try {
			return userDeleteAccount()
				.then(res => {
					return res.data.success;
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		}
		catch (err) {
			return false;

		}
	};

	const checkUserPlan = async (file) => {
		const formData = new FormData();
		formData.append("filesize", file.size);
		try {
			return checkUsage(formData)
				.then(res => {
					if (res.data.error) {

						if (res.data.type == 'once_size') {
							alert({
								title: t("title"),
								message: t(res.data.message, userPlanData.plan.once_size),
								buttonOKText: t('ok'),
							});
						}
						else if (res.data.type == 'count') {
							if (userPlanData.plan.id > 2) {
								alert({
									title: t("title"),
									message: t(res.data.message),
									buttonOKText: t('ok'),
								});
							}
							else {
								// showPopup({
								// 	title: t("title"),
								// 	message: t(res.data.message),
								// 	buttonOKText: t('ok'),
								// });
								showPopup({
									title: "크레딧이 모두 사용되었습니다.",
									message: "현재 Free 플랜의 크레딧을 모두 사용하셨습니다.\nBasic 플랜으로 업그레이드하면\n더 많은 크레딧과 혜택을 계속 이용하실 수 있습니다.",
									buttonText: "플랜 업그레이드",
									onButtonClick: () => {
										navigate('/main', { state: { startPage: 'plan', openPlanPopup: true } });
									}
								});
							}
						}
						else if (res.data.type == 'storage') {
							if (userPlanData.plan.id > 2) {
								alert({
									title: t("title"),
									message: t(res.data.message),
									buttonOKText: t('ok'),
								});
							}
							else {
								// showPopup({
								// 	title: t("title"),
								// 	message: t(res.data.message),
								// 	buttonOKText: t('ok'),
								// });
								showPopup({
									title: "스토리지를 모두 사용되었습니다.",
									message: "현재 Free 플랜의 스토리지를 모두 사용하셨습니다.\nBasic 플랜으로 업그레이드하면\n더 큰 스토리지와 혜택을 계속 이용하실 수 있습니다.",
									buttonText: "플랜 업그레이드",
									onButtonClick: () => {
										navigate('/main', { state: { startPage: 'plan', openPlanPopup: true } });
									}
								});
							}

						}
						else
							//alert(t(res.data.message))
							alert({
								title: t("title"),
								message: t(res.data.message),
								buttonOKText: t('ok'),
							});
						return false;
					}
					else {
						return true;
					}
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		} catch (error) {
			return false;
		}
		return false;
	};

	const isPlanAddCount = async () => {
		try {
			// return getPlanAddCount()
			// 	.then(res => {
			// 		if (res.data.success) {
			// 			const decryptedObj = decryptAES(res.data.data);
			// 			if(!decryptedObj.userData)
			// 			{
			// 				if(decryptedObj.planData)
			// 				{
			// 					return true;
			// 				}
			// 			}

			// 			return false;
			// 		}
			// 		else {
			// 			return false;
			// 		}
			// 	})
			// 	.catch(err => {
			// 		console.log(err.message)
			// 		return false;
			// 	});
		} catch (error) {
			console.log(error.message)
			return false;
		}
		return false;
	};

	const checkFirst = async () => {
		try {
			return checkFirstLogin()
				.then(res => {
					if (res.data.success) {
						if (res.data.data === null)
							return true;

						return false;
					}
					else {
						return false;
					}
				})
				.catch(err => {
					console.log(err.message)
					return false;
				});
		} catch (error) {
			console.log(error.message)
			return false;
		}
		return false;
	};

	return (
		<UserContext.Provider value={{
			user, setUser, login, adminLogin: adminLoginFunc, userTempLogin, googleLogin, registerUser, registerUserWithSocial, logout, loading, userPlanData, loadingUserData, downloadModel,
			updateUserData, getDownloadModel,
			passwordCheck, passwordChange, resetPassword, userDataUpdate, userMarketingUpdate,
			getPlanDescription,
			deleteAccount, checkUserPlan,
			isPlanAddCount, checkFirst
		}}>
			{children}
		</UserContext.Provider>
	);
};

// 7. 훅으로 쉽게 사용
export const useUser = () => useContext(UserContext);
